import {
    LISTING_PACKAGE_ANONYM_LISTING_ID,
    LISTING_PACKAGE_SOCIAL_BOOST_ID,
    LISTING_PACKAGE_PRIVATE_LISTING_ID,
} from '../../marketplace-custom-config';
import config from '../../config';
import { BOOSTING_CH, BOOSTING_DE } from '../EditListingWizard/config';
import { REASON_TO_PAUSE_STATUS_NO_ASSETS } from './constants';

const { listingTypeHorse } = config;

export const formatDateOptions = {
    year: 'numeric',
    day: '2-digit',
    month: '2-digit',
};

const BOOSTING_PATH_BY_COUNTRY = {
    CH: BOOSTING_CH,
    DE: BOOSTING_DE,
};

export const getBoostingPath = country => BOOSTING_PATH_BY_COUNTRY[country] || BOOSTING_CH;

/** "CHF 1'200.00" -> "1'200.00 CHF" */
export const formatPriceForDisplay = formattedPrice =>
    formattedPrice
        .split(' ')
        .reverse()
        .join(' ');

export const getDuplicateListingParams = l => {
    const { publicData } = l.attributes;
    const { anonymousListingTitle } = publicData;

    const duplicateParams = {
        title: anonymousListingTitle || l.attributes.title,
        publicData: {
            ...(publicData || {}),
            viewsNum_temp: 0,
            viewsNum_total: 0,
            type: listingTypeHorse,
            anonymousListingTitle: null,
            anonymousListingPackageIntention: null,
            deanonymizedFor: null,
            listingStatePrevious: null,
            listingClosedAt: null,
            extrapackagesData: {
                [LISTING_PACKAGE_SOCIAL_BOOST_ID]: false,
                [LISTING_PACKAGE_ANONYM_LISTING_ID]: false,
                [LISTING_PACKAGE_PRIVATE_LISTING_ID]: false,
            },
        },
        privateData: {
            duplicateOf: l.id.uuid,
        },
    };

    const insertIfNonEmpty = key => {
        const value = l.attributes[key];
        if (value) {
            duplicateParams[key] = value;
        }
    };

    ['price', 'geolocation', 'description'].forEach(insertIfNonEmpty);

    return duplicateParams;
};
export const checkIfHorseHasNoAssets = listing => {
    const { privateData } = listing?.attributes || {};
    const { reasonToCloseListing } = privateData || {};
    return reasonToCloseListing === REASON_TO_PAUSE_STATUS_NO_ASSETS;
};
/**
 * State of a listing as presented to its owner, e.g. as a suffix of translation keys.
 * Matches the listing state, except for listings paused by the system due to missing assets
 * @return {string} - listing state or "no-assets"
 */
export const getListingDisplayState = listing => {
    const { state } = listing.attributes;

    if (checkIfHorseHasNoAssets(listing)) {
        return REASON_TO_PAUSE_STATUS_NO_ASSETS;
    }
    return state;
};
